import { render, staticRenderFns } from "./quotationDetails.vue?vue&type=template&id=5322b94b&scoped=true"
import script from "./quotationDetails.vue?vue&type=script&lang=js"
export * from "./quotationDetails.vue?vue&type=script&lang=js"
import style0 from "./quotationDetails.vue?vue&type=style&index=0&id=5322b94b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5322b94b",
  null
  
)

export default component.exports